import { LibMenu } from "ngx-mat-base-comp";
import { PermissionsBase, PermissionsGroup } from "src/app/auth/permissions";
import { Module } from "../global";


const mainMenu: LibMenu[] = [
    {
      state: '',
      name: '',    
      type: 'separator',
      icon: '',
      permissions: []
    },
    {
        state: '/core',
        name: 'global.MainMenu',
        type: 'extLink',
        icon: 'arrow_back',
        permissions: [PermissionsBase.Hub]
      },
  ]

  export const  settingMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.Settings',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.SettingReadWriteOrDelete
    },
    {
        state: 'edi-config',
        name: 'Edi.Config',
        type: 'link',
        icon: 'settings',
        permissions: PermissionsGroup.SettingReadWriteOrDelete
    },
    ...mainMenu
   ];

   export const  saleMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.Sales',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.SalesReadWriteOrDelete
    },
    {
        state: 'sales-order',
        name: 'global.SalesOrder',
        type: 'link',
        icon: 'receipt',
        permissions: PermissionsGroup.SalesReadWriteOrDelete
    },
    ...mainMenu
   ]

   

export const  reportMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.Reports',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.ReportReadWriteOrDelete
    },
    {
        state: 'config',
        name: 'Report.Config',
        type: 'link',
        icon: 'library_books',
        permissions: PermissionsGroup.ReportReadWriteOrDelete
    },
    ...mainMenu
];

export const  receivingMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.Receiving',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.ReceivingReadWriteOrDelete
    },
    {
        state: 'receivings',
        name: 'global.Receiving',
        type: 'link',
        icon: 'input',
        permissions: PermissionsGroup.ReceivingReadWriteOrDelete
    },
    {
        state: 'inventory/location',
        name: 'global.Location',
        type: 'extLink',
        icon: 'pallet',
        permissions: PermissionsGroup.InventoryReadWriteOrDelete
    },
    ...mainMenu
];

export const  techRepairMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.TechRepair',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.TechRepairReadWriteOrDelete
    },
    {
        state: 'repair',
        name: 'global.Repair',
        type: 'link',
        icon: 'handyman',
        permissions: PermissionsGroup.TechRepairReadWriteOrDelete
    },
    {
        state: 'inventory/location',
        name: 'global.Location',
        type: 'extLink',
        icon: 'pallet',
        permissions: PermissionsGroup.InventoryReadWriteOrDelete
    },
    ...mainMenu
];

export const inspectionMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.TechInspection',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.InspectionReadWriteOrDelete
    },
    {
        state: 'inspection',
        name: 'global.Inspection',
        type: 'link',
        icon: 'beenhere',
        permissions: PermissionsGroup.InspectionReadWriteOrDelete
    },
    {
        state: 'label-config',
        name: 'global.LabelConfig',
        type: 'link',
        icon: 'label',
        permissions: PermissionsGroup.InspectionReadWriteOrDelete
    },
    {
        state: 'inventory/location',
        name: 'global.Location',
        type: 'extLink',
        icon: 'pallet',
        permissions: PermissionsGroup.InventoryReadWriteOrDelete
    },
    ...mainMenu
];

export const  billingMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.Billing',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.BillingReadWriteOrDelete
    },
    {
        state: 'invoice',
        name: 'global.Invoice',
        type: 'link',
        icon: 'receipt',
        permissions: PermissionsGroup.BillingReadWriteOrDelete
    },
    {
        state: 'pricing-configuration',
        name: 'global.PricingConfiguration',
        type: 'link',
        icon: 'subtitles_gear',
        permissions: PermissionsGroup.BillingReadWriteOrDelete
    },
    {
        state: 'payment-term',
        name: 'global.PaymentTerm',
        type: 'link',
        icon: 'price_change',
        permissions: PermissionsGroup.BillingReadWriteOrDelete
    },
    
    ...mainMenu
];

export const  zeusMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.Zeus',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.ZeusReadWriteOrDelete
    },
    {
        state: 'transaction',
        name: 'global.Transaction',
        type: 'link',
        icon: 'paid',
        permissions: PermissionsGroup.ZeusReadWriteOrDelete
    },
    ...mainMenu
];

export const  inventoryMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.Inventory',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.InventoryReadWriteOrDelete
    },
    {
        state: 'inventory',
        name: 'global.Inventory',
        type: 'link',
        icon: 'inventory_2',
        permissions: PermissionsGroup.InventoryReadWriteOrDelete
    },
    {
        state: 'event',
        name: 'global.Event',
        type: 'link',
        icon: 'list_alt_check',
        permissions: PermissionsGroup.InventoryReadWriteOrDelete
    },
    {
        state: 'location',
        name: 'global.Location',
        type: 'link',
        icon: 'pallet',
        permissions: PermissionsGroup.InventoryReadWriteOrDelete
    },
    ...mainMenu
];

export const  entityMenuItems: LibMenu[] = [
    {
        state: '',
        name: 'global.Entity',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: 'client',
        name: 'global.Client',
        type: 'link',
        icon: 'business',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: 'customer',
        name: 'global.Customer',
        type: 'link',
        icon: 'person',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: 'employee',
        name: 'global.Employee',
        type: 'link',
        icon: 'badge',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: 'store',
        name: 'global.Store',
        type: 'link',
        icon: 'store',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: '',
        name: 'global.Item',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: 'item',
        name: 'global.Item',
        type: 'link',
        icon: 'takeout_dining',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: 'item-category',
        name: 'global.Category',
        type: 'link',
        icon: 'category',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: 'item-division',
        name: 'global.Division',
        type: 'link',
        icon: 'workspaces',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: '',
        name: 'global.Location',
        type: 'separator',
        icon: '',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    {
        state: 'storage-unit',
        name: 'global.StorageUnit',
        type: 'link',
        icon: 'check_box_outline_blank',
        permissions: PermissionsGroup.EntityReadWriteOrDelete
    },
    ...mainMenu
];


  export const listMenu: {module: string, items: LibMenu[]}[] = [
    {
        module: '',
        items: [
            {
                state: '',
                name: 'global.Modules',    
                type: 'separator',
                icon: '',
                permissions: [PermissionsBase.Hub]
            },
            {
                state: Module.Sales,
                name: 'global.Sales',
                type: 'extLink',
                icon: 'receipt',
                permissions: PermissionsGroup.SalesReadWriteOrDelete
            },
            {
                state: Module.Entity,
                name: 'global.Entities',
                type: 'extLink',
                icon: 'all_out',
                 permissions: PermissionsGroup.EntityReadWriteOrDelete
            },
            {
                state: Module.Receiving,
                name: 'global.Receiving',
                type: 'extLink',
                icon: 'input',
                permissions: PermissionsGroup.ReceivingReadWriteOrDelete
            },
            {
                state: Module.TechRepair,
                name: 'global.Repair',
                type: 'extLink',
                icon: 'handyman',
                permissions: PermissionsGroup.TechRepairReadWriteOrDelete
            },
            {
                state: Module.Inspection,
                name: 'global.Inspection',
                type: 'extLink',
                icon: 'beenhere',
                permissions: PermissionsGroup.InspectionReadWriteOrDelete
            },
            {
                state: Module.Inventory,
                name: 'global.Inventory',
                type: 'extLink',
                icon: 'inventory_2',
                permissions: PermissionsGroup.InventoryReadWriteOrDelete
            },
            {
                state: Module.Billing,
                name: 'global.Billing',
                type: 'extLink',
                icon: 'request_page',
                permissions: PermissionsGroup.BillingReadWriteOrDelete
            },
            {
                state: Module.Zeus,
                name: 'global.Zeus',
                type: 'extLink',
                icon: 'visibility',
                permissions: PermissionsGroup.ZeusReadWriteOrDelete
            },
            {
                state: Module.Report,
                name: 'global.Reports',
                type: 'extLink',
                icon: 'library_books',
                permissions: PermissionsGroup.ReportReadWriteOrDelete
            },
            {
                state: Module.Setting,
                name: 'global.Settings',
                type: 'extLink',
                icon: 'settings',
                permissions: PermissionsGroup.SettingReadWriteOrDelete
            },
        ]
    },
    {
        module: Module.Sales,
        items: saleMenuItems
    },
    {
        module: Module.Receiving,
        items: receivingMenuItems
    },
    {
        module: Module.TechRepair,
        items: techRepairMenuItems
    },
    {
        module: Module.Inspection,
        items: inspectionMenuItems
    },
    {
        module: Module.Inventory,
        items: inventoryMenuItems
    },
    {
        module: Module.Billing,
        items: billingMenuItems
    },
    {
        module: Module.Zeus,
        items: zeusMenuItems
    },
    {
        module: Module.Entity,
        items: entityMenuItems
    },
    {
        module: Module.Report,
        items: reportMenuItems
    },
    {
        module: Module.Setting,
        items: settingMenuItems
    }
];



